import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "../../data";
import { scrollTo, EASE } from "../../lib/anim";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (t) => {
    setOpen(false);
    setTimeout(() => scrollTo(t), 60);
  };

  return (
    <>
      <motion.header
        initial={{ y: -80, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1, ease: EASE, delay: 0.2 }}
        className="fixed top-0 left-0 right-0 z-50"
        data-testid="site-nav"
      >
        <div
          className={`transition-colors duration-500 ${
            scrolled ? "bg-[#060607]/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
          }`}
        >
          <div className="max-w-[1500px] mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
            <button
              onClick={() => go("hero")}
              data-testid="nav-logo"
              className="flex items-center hover:opacity-75 transition-opacity duration-300"
              aria-label="MGB Aviation"
            >
              <img src="/logo/mgb-aviation-primary.png" alt="MGB Aviation" title="MGB Aviation" draggable="false" className="h-5 lg:h-6 w-auto" />
            </button>

            <nav className="hidden md:flex items-center gap-10">
              {NAV_LINKS.map((l) => (
                <button
                  key={l.target}
                  onClick={() => go(l.target)}
                  data-testid={`nav-link-${l.target}`}
                  className="font-mono-x text-[11px] tracking-[0.24em] uppercase text-white/55 hover:text-white transition-colors duration-300"
                >
                  {l.label}
                </button>
              ))}
              <button
                onClick={() => go("contact")}
                data-testid="nav-cta"
                className="font-mono-x text-[11px] tracking-[0.24em] uppercase text-[#060607] bg-white px-5 py-2.5 hover:bg-white/80 transition-colors duration-300"
              >
                Contatti
              </button>
            </nav>

            <button
              className="md:hidden text-white"
              onClick={() => setOpen((v) => !v)}
              data-testid="nav-menu-toggle"
              aria-label="Menu"
            >
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>
      </motion.header>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
            className="fixed inset-0 z-40 bg-[#060607]/97 backdrop-blur-xl md:hidden flex flex-col items-start justify-center gap-6 px-10"
            data-testid="mobile-menu"
          >
            {[...NAV_LINKS, { label: "Contatti", target: "contact" }].map((l, i) => (
              <motion.button
                key={l.target}
                initial={{ opacity: 0, x: -24 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.1 + i * 0.07, ease: EASE }}
                onClick={() => go(l.target)}
                className="font-display text-4xl text-white/90 tracking-tight"
              >
                {l.label}
              </motion.button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
